import type * as React from "react";

import { formatBRL, MAX_VALUE_CENTS } from "@/lib/currency.ts";

function CurrencyInput({
	value,
	onChange,
	...props
}: Omit<React.ComponentProps<"input">, "value" | "onChange" | "type"> & {
	value: number | null;
	onChange: (cents: number | null) => void;
}) {
	function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
		const digits = event.target.value.replace(/\D/g, "").replace(/^0+/, "");
		if (!digits) {
			onChange(null);
			return;
		}
		onChange(Math.min(Number(digits), MAX_VALUE_CENTS));
	}

	return (
		<input
			type="text"
			inputMode="numeric"
			autoComplete="off"
			data-slot="input"
			value={value === null ? "" : formatBRL(value)}
			onChange={handleChange}
			{...props}
		/>
	);
}

export { CurrencyInput };
